import { getElectricityCategories, getCableCategories, getCableProducts, getEducationCategories } from '@/api/bills'

const actions = {
    FETCH_ELECTRICITY_CATEGORIES: ({ commit }) => {
        getElectricityCategories()
            .then((data) => {
                commit('COMMIT_ELECTRICITY_CATEGORIES', data.data.data.servicecategory)
            })
            .catch((error) => {
                console.dir(error)
            })
    },

    FETCH_CABLE_CATEGORIES: ({ commit }) => {
        getCableCategories()
            .then((data) => {
                commit('COMMIT_CABLE_CATEGORIES', data.data.data.servicecategory)
            })
            .catch((error) => {
                console.dir(error)
            })
    },

    FETCH_CABLE_PRODUCTS: ({ commit }, payload) => {
        getCableProducts(payload.cardNumber, payload.type)
            .then((data) => {
                commit('COMMIT_CABLE_PRODUCTS', data.data.data.productcategories)
            })
            .catch((error) => {
                console.dir(error)
            })
    },

    FETCH_EDUCATION_CATEGORIES: ({ commit }) => {
        getEducationCategories()
            .then((data) => {
                commit('COMMIT_EDUCATION_CATEGORIES', data.data.categories)
            })
            .catch((err) => {
                console.dir(err)
            })
    },
}

export default actions
